import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addUpdateVenueRes;
export const addUpdateVenueTodo = createAsyncThunk('addUpdateVenue', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/add_update_venue',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "venue_id": data.id,
                "venue_name": data.venue,
                "created_by": user_id.vemp_code,
                "status": data.status,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addUpdateVenueRes = res.data
    } catch (error) {
        return addUpdateVenueRes = error.response.data
    }
})